import React from 'react';
import { Badge } from '@ncoder/ui';

interface HealthCheckItemProps {
  service: string;
  status: 'healthy' | 'warning' | 'critical';
  responseTime?: string;
  lastChecked?: string;
}

export const HealthCheckItem: React.FC<HealthCheckItemProps> = ({
  service,
  status,
  responseTime,
  lastChecked,
}) => {
  const getStatusVariant = () => {
    switch (status) {
      case 'healthy':
        return 'default';
      case 'warning':
        return 'secondary';
      case 'critical':
        return 'destructive';
      default:
        return 'default';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'healthy':
        return 'Healthy';
      case 'warning':
        return 'Warning';
      case 'critical':
        return 'Critical';
      default:
        return 'Unknown';
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">{service}</span>
          <Badge variant={getStatusVariant() as any}>{getStatusText()}</Badge>
        </div>
        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          {responseTime && <span>{responseTime}</span>}
          {lastChecked && <span>Last checked: {lastChecked}</span>}
        </div>
      </div>
    </div>
  );
};
